import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
    phone_number: Yup.string().required('هذا الحقل مطلوب'),
    full_name: Yup.string().trim().required('هذا الحقل مطلوب'),
    message: Yup.string().trim().max(500, 'تجاوزت الرسالة الحد المسموح من أحرف').required('هذا الحقل مطلوب'),
    reason: Yup.string().trim().required('هذا الحقل مطلوب'),
    email: Yup.string().trim().email('تنسيق الايميل غير صالح ')
});

export const formikProps = {
    validationSchema,
    formik: {
        onChangeValidate: false,
        onBlurValidate: false,
    },
    initialValues: {
        phone_number: '',
        full_name: '',
        message: '',
        email: '',
        reason: ''
    },
};